import { LOCALE_DEFAULT, dateInZone } from '@equinox/shared';
import { REPORT_TIME_ZONE } from './reportDates.js';

export function formatDateTime(iso: string | null, locale: string = LOCALE_DEFAULT): string {
  if (!iso) return '';
  return new Intl.DateTimeFormat(locale, { dateStyle: 'short', timeStyle: 'short' }).format(new Date(iso));
}

export function formatDate(iso: string | null, locale: string = LOCALE_DEFAULT): string {
  if (!iso) return '';
  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium' }).format(new Date(iso));
}

/** Hours elapsed since an ISO timestamp. Used for the "terminal gone quiet" warning. */
export function hoursSince(iso: string | null): number | null {
  if (!iso) return null;
  return (Date.now() - new Date(iso).getTime()) / (1000 * 60 * 60);
}

/**
 * Calendar date of an instant IN THE REPORT TIME ZONE, as YYYY-MM-DD.
 * Never `toISOString().slice`: that yields the UTC date, which in Mexico
 * City (UTC-6) is already tomorrow every evening from 18:00 onward — the
 * "today's report is empty at night" bug (2026-08-01). Business days are
 * report-timezone days.
 */
export function todayISO(): string {
  return dateInZone(new Date(), REPORT_TIME_ZONE);
}

export function daysAgoISO(days: number): string {
  return dateInZone(new Date(Date.now() - days * 24 * 60 * 60 * 1000), REPORT_TIME_ZONE);
}

export function startOfMonthISO(): string {
  return `${todayISO().slice(0, 8)}01`;
}
